import React from 'react';
import { Table, Button, Card, Modal, Icon, message, Alert, Divider, Input, Select, Row, Col, Spin } from 'antd';
import { withAppContext } from 'context/AppContext';
import { withRouter } from 'react-router-dom';
import { getHosts } from 'utils/apis/host';
import moment from 'moment';
import queryString from 'query-string';
import styles from './BillingInvoice.module.css';
import MonthPicker from 'components/MonthPicker/MonthPicker';

import {
  getInvoices,
  createInvoice,
  updateInvoice,
  deleteInvoice,
  updatePaymentStatus,
  getFpxPaymentStatus,
  getInvoiceById,
  getInvoiceByHost
} from 'utils/apis/billingInvoice';
import { generateBillingDisplayFee } from 'utils/general';

import InvoiceModal from './components/InvoiceModal/InvoiceModal';
import ConfirmationModal from './components/ConfirmationModal/ConfirmationModal';
import PrivateDownloadLink from 'components/PrivateDownloadLink/PrivateDownloadLink';
import { buildAPBillingInvoiceUri } from 'utils/routes';
import { MONTH_FORMAT } from 'utils/constants';

const Option = Select.Option;

const DeleteModal = ({ record }) => (
  <div>
    <Alert message="Warning" description="You will not be able to undo this action." type="warning" showIcon />
    <p />
    <Card title={`Invoice Number: ${record.invoiceNo} `}>
      <p>
        <b>Invoice Amount: </b>
        {generateBillingDisplayFee(record.amount, true, null, record.currency)}
      </p>
      <p>
        <b>Invoice Date: </b>
        {moment(record.invoiceDate).format('YYYY-MM-DD')}
      </p>
      <p>
        <b>Invoice Due Date: </b>
        {moment(record.invoiceDueDate).format('YYYY-MM-DD')}
      </p>
      <p>
        <b>Payment Status: </b>
        {record.paymentStatus.charAt(0).toUpperCase() + record.paymentStatus.slice(1)}
      </p>
      <p>
        <b>Invoice PDF File: </b>
        {!!record.files
          ? record.files.map((file, index) => (
              <div key={file.key || file.link}>
                <PrivateDownloadLink file={file} />
              </div>
            ))
          : 'Not Included'}
      </p>
    </Card>
  </div>
);

class BillingInvoice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      invoices: [],
      searchInvoiceText: '',
      searchHostText: '',
      originalData: [],
      hostEmail: '',
      selectedInvoice: {},
      filteredHostOptions: [],
      isModalClicked: false,
      isEditClicked: false,
      isDeleteClicked: false,
      isConfirmedPayment: false,
      confirmationData: [],
      currentYearWithMonth: moment().format('YYYY-MM'),
      selectedHost: '',
      deleteLoading: false
    };
  }

  //take all in one go (no pagination)
  getNumbersOfInvoices = searchQuery => {
    if (this.props.host) {
      getInvoiceByHost(this.props.host).then(invoices => {
        console.log(invoices);
        this.setState({
          originalData: invoices,
          invoices: invoices.map(data => ({
            ...data,
            key: data._id
          }))
        });
      });
    } else {
      getInvoices()
        .then(invoices => {
          let data = invoices;
          const hostQuery = queryString.parse(searchQuery);
          if (hostQuery) {
            if (hostQuery.host && hostQuery.host !== 'all') {
              console.log(data, 1);
              console.log(hostQuery.host);
              data = data.filter(invoice => String(invoice.host._id) === String(hostQuery.host));
              console.log(data, 45);
            }

            if (hostQuery.date) {
              data = data.filter(invoice => {
                const invoiceDate = invoice.invoiceDate
                  .split('-')
                  .slice(0, 2)
                  .join('-');
                return invoiceDate === hostQuery.date;
              });
            } else {
              data = data.filter(invoice => {
                const invoiceDate = invoice.invoiceDate
                  .split('-')
                  .slice(0, 2)
                  .join('-');
                return invoiceDate === this.state.currentYearWithMonth;
              });
            }
          }

          this.setState({
            originalData: invoices,
            invoices: data.map(data => ({
              ...data,
              key: data._id
            }))
          });
        })
        .catch(ex => {
          console.log(ex);
        });
    }
  };

  constructReadableYearMonthFormat = (year, month) => {
    if (year && month > -1) {
      return month < 9 ? `${year}-0${month + 1}` : `${year}-${month + 1}`;
    } else {
      const year = new Date().getFullYear();
      const month = new Date().getMonth();
      return month < 9 ? `${year}-0${month + 1}` : `${year}-${month + 1}`;
    }
  };

  setURLQuery = ({ host, date }) => {
    const { month, year } = this.state;
    const { history } = this.props;

    if (!date) {
      date = this.constructReadableYearMonthFormat(year, month);
    }
    const monthWithYearInString = moment(date).format(MONTH_FORMAT);
    history.replace(buildAPBillingInvoiceUri({ host: host, date: monthWithYearInString }));
  };

  componentDidMount = async () => {
    const { history } = this.props;
    const invoiceQuery = queryString.parse(history.location.search);
    const searchQuery = history.location.search;
    const hostQuery = queryString.parse(searchQuery);

    if (searchQuery.includes('?success')) {
      Modal.success({
        centered: true,
        title: 'Payment succesfully made!',
        content: 'You have successfuly made a payment.',
        onOk() {},
        onCancel() {}
      });
      if (invoiceQuery) {
        await updatePaymentStatus(invoiceQuery.token);
        this.getNumbersOfInvoices(searchQuery);
      }
    } else if (searchQuery.includes('?fpx_success=true')) {
      const paymentQuery = queryString.parse(searchQuery);
      getFpxPaymentStatus(paymentQuery.payment_intent)
        .then(async paymentStatus => {
          const charges = paymentStatus.charges.data[0];
          this.setState({
            confirmationData: charges || '',
            isConfirmedPayment: true
          });

          if (paymentQuery.token && charges && charges.status === 'succeeded') {
            await updatePaymentStatus(invoiceQuery.token);
            this.getNumbersOfInvoices(searchQuery);
          }
        })
        .catch(ex => {
          console.log(ex);
        });
    } else if (searchQuery === '?cancelled') {
      Modal.error({
        centered: true,
        title: 'There was an error processing your payment.',
        content: 'Please try making your payment again.',
        onOk() {},
        onCancel() {}
      });
    }

    this.getNumbersOfInvoices(searchQuery);

    getHosts()
      .then(res => {
        const { originalData } = this.state;

        const filteredHostOptions = originalData.map(ori => {
          return res.data.find(data => {
            return data._id === ori.host._id;
          });
        });

        this.setState({
          filteredHostOptions: [...new Set(filteredHostOptions)].map(data => {
            return { value: data.name, key: data._id };
          })
        });
      })
      .catch(ex => {
        console.log(ex);
      });
    if (!this.props.noUrlModification) {
      this.setURLQuery({ host: hostQuery.host, date: hostQuery.date });
    }
    let currentYearWithMonth;

    if (hostQuery.date) {
      currentYearWithMonth = hostQuery.date;
    } else {
      currentYearWithMonth = this.state.currentYearWithMonth;
    }

    this.setState({
      currentYearWithMonth,
      selectedHost: hostQuery.host
    });
  };

  columns = ({ isAdmin, isAdminReadOnly }) => {
    return [
      {
        title: 'Invoice Number',
        dataIndex: 'invoiceNo',
        key: 'invoiceNo',
        sorter: (a, b) => a.invoiceNo && b.invoiceNo && a.invoiceNo.localeCompare(b.invoiceNo),
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div className="custom-filter-dropdown">
            <Input
              ref={ele => (this.searchInput = ele)}
              placeholder="Search invoice number"
              value={selectedKeys[0]}
              onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
              onPressEnter={confirm}
              name="searchInvoiceText"
            />
            <Button type="primary" onClick={confirm}>
              Search
            </Button>
            <Button onClick={clearFilters}>Reset</Button>
          </div>
        ),
        filterIcon: filtered => <Icon type="search" style={{ color: filtered ? '#00b9c6' : '#aaa' }} />,
        onFilter: (value, record) => record.invoiceNo.toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
          if (visible) {
            setTimeout(() => {
              this.searchInput.focus();
            });
          }
        },
        render: (text, record) => {
          const isUnpaid = record.paymentStatus === 'unpaid';

          return (
            <span onClick={() => this.handleOnClickedEditBtn(record)} className={styles.clickableInvoice}>
              {isUnpaid ? (
                <>
                  <Icon className={`${styles.warningOverdueInvoice}`} type="warning" />
                  {record.invoiceNo}
                </>
              ) : (
                record.invoiceNo
              )}
            </span>
          );
        }
      },
      {
        title: 'Host Name',
        dataIndex: 'host.name',
        key: 'host.name',
        sorter: (a, b) => a.host.name && b.host.name && a.host.name.localeCompare(b.host.name),
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div className="custom-filter-dropdown">
            <Input
              ref={ele => (this.searchInput = ele)}
              placeholder="Search host name"
              value={selectedKeys[0]}
              onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
              onPressEnter={confirm}
              name="searchHostText"
            />
            <Button type="primary" onClick={confirm}>
              Search
            </Button>
            <Button onClick={clearFilters}>Reset</Button>
          </div>
        ),
        filterIcon: filtered => <Icon type="search" style={{ color: filtered ? '#00b9c6' : '#aaa' }} />,
        onFilter: (value, record) => record.host.name.toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
          if (visible) {
            setTimeout(() => {
              this.searchInput.focus();
            });
          }
        }
      },
      {
        title: 'Invoice Date',
        dataIndex: 'invoiceDate',
        key: 'invoiceDate',
        defaultSortOrder: 'descend',
        sorter: (a, b) => a.invoiceDate && b.invoiceDate && a.invoiceDate.localeCompare(b.invoiceDate)
      },
      {
        title: 'Invoice Due Date',
        dataIndex: 'invoiceDueDate',
        key: 'invoiceDueDate',
        sorter: (a, b) => a.invoiceDueDate && b.invoiceDueDate && a.invoiceDueDate.localeCompare(b.invoiceDueDate)
      },
      {
        title: 'Invoice Amount',
        dataIndex: 'amount',
        key: 'amount',
        sorter: (a, b) => a.amount && b.amount && a.amount.localeCompare(b.amount),
        render: (text, record) => generateBillingDisplayFee(record.amount, true, null, record.currency)
      },
      {
        title: 'Payment Status',
        dataIndex: 'paymentStatus',
        key: 'paymentStatus',
        filters: Array.from(
          new Set(
            this.state.invoices.map(item => {
              return item.paymentStatus.charAt(0).toUpperCase() + item.paymentStatus.slice(1);
            })
          )
        ).map(item => {
          return { text: item, value: item };
        }),
        onFilter: (value, record) => record.paymentStatus === value.toLowerCase(),
        render: (text, record) => record.paymentStatus.charAt(0).toUpperCase() + record.paymentStatus.slice(1)
      },
      {
        title: 'INV & OR Received',
        dataIndex: 'officialInvoice',
        key: 'invoiceReceived',
        render: (text, record) => {
          const hasInvoice = record.officialInvoice && record.officialInvoice.length > 0;
          const hasReceipt = record.officialReceipt && record.officialReceipt.length > 0;

          if (hasInvoice && hasReceipt) {
            return 'Yes';
          } else if (hasInvoice) {
            return 'Invoice Only';
          } else if (hasReceipt) {
            return 'Receipt Only';
          } else {
            return 'No';
          }
        }
      },
      {
        title: 'Invoice Sent',
        dataIndex: 'emailSent',
        key: 'emailSent',
        filters: [{ text: 'Yes', value: true }, { text: 'No', value: false }],
        onFilter: (value, record) => record.emailSent === value,
        render: (text, record) => (record.emailSent ? 'Yes' : 'No')
      },
      {
        title: 'Action',
        key: 'action',
        width: 120,
        render: (text, record) => {
          return (
            <div>
              {isAdmin ? (
                <>
                  <span>
                    <Icon
                      type="edit"
                      className={isAdminReadOnly ? styles.actionIconDisabled : styles.actionIcon}
                      onClick={() => {
                        if (!isAdminReadOnly) {
                          this.handleOnClickedEditBtn(record);
                        }
                      }}
                    />
                  </span>
                  <Divider type="vertical" />
                  <span>
                    <Icon
                      type="delete"
                      className={isAdminReadOnly ? styles.actionIconDisabled : styles.actionIcon}
                      onClick={() => {
                        if (!isAdminReadOnly) {
                          this.handleOnClickedDeleteBtn(record);
                        }
                      }}
                    />
                  </span>
                </>
              ) : (
                <span>
                  <Icon type="eye" className={styles.actionIcon} onClick={() => this.handleOnClickedViewBtn(record)} />
                </span>
              )}
            </div>
          );
        }
      }
    ];
  };

  handleOnCreateSubmit = (form, files, officialInvoice, officialReceipt, record, emailFlag = false, hostEmail) => {
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        Modal.confirm({
          title: 'Are you sure you want to create this invoice?',
          content: `This will send a confirmation email to: ${hostEmail}`,
          onOk() {
            const formattedInvoice = {
              host: values.host,
              invoiceNo: values.invoiceNo,
              invoiceDate: values.invoiceDate.format('YYYY-MM-DD'),
              invoiceDueDate: values.invoiceDueDate.format('YYYY-MM-DD'),
              amount: values.amount,
              paymentStatus: values.paymentStatus,
              files,
              officialInvoice,
              officialReceipt,
              emailSent: true
            };
            createInvoice(formattedInvoice)
              .then(data => {
                message.success('Invoice is successfully created!');
                !!data && window.location.reload();
              })
              .catch(ex => {
                message.error(ex.toString());
                console.error(ex);
              });
          },
          onCancel() {}
        });
      }
    });
  };

  handleOnEditSubmit = (form, files, officialInvoice, officialReceipt, record, emailFlag = false, hostEmail) => {
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        let formattedInvoice = {
          host: values.host,
          invoiceNo: values.invoiceNo,
          invoiceDate: values.invoiceDate.format('YYYY-MM-DD'),
          invoiceDueDate: values.invoiceDueDate.format('YYYY-MM-DD'),
          amount: values.amount || 0,
          paymentStatus: values.paymentStatus,
          files: files || record.files,
          officialInvoice: officialInvoice || record.officialInvoice,
          officialReceipt: officialReceipt || record.officialReceipt,
          sendEmail: emailFlag,
          currency: record.currency || 'MYR'
        };
        if (emailFlag) {
          formattedInvoice.emailSent = true;
          Modal.confirm({
            title: `Are you sure you update this invoice and send email?`,
            content: `This will send an email to: ${hostEmail}`,
            onOk() {
              updateInvoice(record._id, formattedInvoice)
                .then(data => {
                  message.success('Update success!');
                  !!data && window.location.reload();
                })
                .catch(ex => {
                  message.error(ex.toString());
                  console.error(ex);
                });
            },
            onCancel() {}
          });
        } else {
          Modal.confirm({
            title: 'Are you sure you want to update this invoice?',
            onOk() {
              updateInvoice(record._id, formattedInvoice)
                .then(data => {
                  message.success('Update success!');
                  !!data && window.location.reload();
                })
                .catch(ex => {
                  message.error(ex.toString());
                  console.error(ex);
                });
            },
            onCancel() {}
          });
        }
      }
    });
  };

  handleGeneratePDF = (form, files, officialInvoice, officialReceipt, record, emailFlag = false, hostEmail) => {
    const { history } = this.props;
    const { isEditClicked } = this.state;

    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const formattedInvoice = {
          host: values.host,
          invoiceNo: values.invoiceNo,
          invoiceDate: values.invoiceDate.format('YYYY-MM-DD'),
          invoiceDueDate: values.invoiceDueDate.format('YYYY-MM-DD'),
          amount: values.amount,
          paymentStatus: values.paymentStatus,
          files,
          officialInvoice,
          officialReceipt
        };

        history.push({
          pathname: `${buildAPBillingInvoiceUri()}/${values.host}/${values.invoiceDate.format('YYYY-MM')}/preview`,
          state: { formattedInvoice, isEditClicked, record, hostEmail }
        });
      }
    });
  };

  handleOnDeleteSubmit = () => {
    const { selectedInvoice } = this.state;
    Modal.confirm({
      title: 'Are you sure you want to delete this invoice?',
      onOk: () => {
        this.setState({ deleteLoading: true });
        deleteInvoice({ id: selectedInvoice._id })
          .then(() => {
            message.success('Invoice deleted!');
            window.location.reload();
          })
          .catch(ex => {
            console.log(ex);
            message.error('Failed to delete invoice');
          })
          .finally(() => {
            this.setState({ deleteLoading: false });
          });
      },
      onCancel() {}
    });
  };

  handleOnClickedViewBtn = record => {
    this.setState({
      selectedInvoice: record,
      isModalClicked: true
    });
  };

  handleOnClickedEditBtn = record => {
    this.setState({
      selectedInvoice: record,
      isModalClicked: true,
      isEditClicked: true
    });
  };

  handleOnClickedDeleteBtn = record => {
    this.setState({
      isDeleteClicked: true,
      selectedInvoice: record
    });
  };

  handleOnDeleteCancel = () => {
    this.setState({
      isDeleteClicked: false
    });
  };

  handleOnModalClicked = () => {
    this.setState({
      isModalClicked: true,
      selectedInvoice: null
    });
  };

  handleOnCancelModal = () => {
    this.setState({
      isModalClicked: false,
      isEditClicked: false
    });
  };

  handleOnCancelConfirmation = () => {
    this.setState({
      isConfirmedPayment: false
    });
  };

  handleOnHostChange = selectedHost => {
    const { originalData, currentYearWithMonth } = this.state;

    if (selectedHost === 'all') {
      this.setState({
        invoices: originalData.filter(data => {
          const invoiceDate = data.invoiceDate
            .split('-')
            .slice(0, 2)
            .join('-');
          return invoiceDate === this.state.currentYearWithMonth;
        })
      });
    } else {
      this.setState({
        invoices: originalData.filter(data => {
          const invoiceDate = data.invoiceDate
            .split('-')
            .slice(0, 2)
            .join('-');
          return String(data.host._id) === String(selectedHost) && invoiceDate === this.state.currentYearWithMonth;
        })
      });
    }
    // const { history } = this.props;
    // history.push(`${history.location.pathname}?host=${selectedHost}`);
    this.setState({ selectedHost });
    if (!this.props.noUrlModification) {
      this.setURLQuery({ host: selectedHost, date: currentYearWithMonth });
    }
  };

  handleOnMonthChange = date => {
    const { originalData, selectedHost } = this.state;

    const newYearWithMonth = moment(date).format('YYYY-MM');

    let filteredData = originalData.filter(data => {
      const invoiceDate = data.invoiceDate
        .split('-')
        .slice(0, 2)
        .join('-');
      return invoiceDate === newYearWithMonth;
    });

    if (selectedHost && selectedHost !== 'all') {
      filteredData = filteredData.filter(data => String(data.host._id) === String(selectedHost));
    }

    this.setState({
      invoices: filteredData,
      currentYearWithMonth: newYearWithMonth
    });

    if (!this.props.noUrlModification) {
      this.setURLQuery({ host: selectedHost, date: newYearWithMonth });
    }
  };
  render() {
    const { checkIsAdmin, history, checkIsAdminReadOnly, isBanned } = this.props;
    const {
      isModalClicked,
      isDeleteClicked,
      filteredHostOptions,
      invoices,
      selectedInvoice,
      isConfirmedPayment,
      confirmationData,
      isEditClicked,
      deleteLoading
    } = this.state;
    const hostQuery = queryString.parse(history.location.search);
    const hostDefaultValue = hostQuery.host || 'all';

    return (
      <>
        {isBanned && <Alert message="Warning" description="Please clear your payment in order to continue to use system." type="warning" showIcon />}
        <Card className={!this.props.noUrlModification ? styles.billingCard : styles.billingCardHostDetails}>
          {isConfirmedPayment && (
            <ConfirmationModal visible={isConfirmedPayment} confirmationData={confirmationData} onCancel={this.handleOnCancelConfirmation} />
          )}
          {isModalClicked && (
            <InvoiceModal
              visible={isModalClicked}
              handleOnInvoiceSubmit={selectedInvoice ? this.handleOnEditSubmit : this.handleOnCreateSubmit}
              record={selectedInvoice}
              isEditClicked={isEditClicked}
              formDisabled={!checkIsAdmin()}
              onCancel={this.handleOnCancelModal}
              isGeneratePDFClicked={this.handleGeneratePDF}
              monthWithYear={this.state.currentYearWithMonth}
            />
          )}
          {isDeleteClicked && (
            <Modal
              visible={isDeleteClicked}
              maskClosable={false}
              title={`Invoice Number: ${selectedInvoice.invoiceNo}`}
              onCancel={this.handleOnDeleteCancel}
              footer={[
                <Button key="back" onClick={this.handleOnDeleteCancel} disabled={deleteLoading}>
                  Cancel
                </Button>,
                <Button key="submit" type="primary" onClick={this.handleOnDeleteSubmit} loading={deleteLoading}>
                  Delete
                </Button>
              ]}
            >
              <Spin spinning={deleteLoading} tip="Deleting invoice...">
                <DeleteModal record={selectedInvoice} />
              </Spin>
            </Modal>
          )}
          {checkIsAdmin() && (
            <div className="list-card-control-section">
              <Row type="flex">
                <Col
                  style={{
                    marginRight: '8px',
                    marginBottom: '8px'
                  }}
                >
                  <Button type="primary" icon="plus" onClick={this.handleOnModalClicked} disabled={checkIsAdminReadOnly()}>
                    Create Invoice
                  </Button>
                </Col>
                <Col>
                  <Alert
                    type="info"
                    description={
                      <span>
                        <strong>Visible to Admin Only</strong>
                      </span>
                    }
                    style={{
                      padding: 0,
                      paddingLeft: 8,
                      paddingRight: 8,
                      paddingTop: 2,
                      paddingBottom: 2
                    }}
                  />
                </Col>
              </Row>

              {!this.props.noUrlModification && (
                <>
                  <MonthPicker
                    todayButtonId="today-date-button3-report"
                    label={'Month: '}
                    defaultValue={moment(this.state.currentYearWithMonth || moment())} // Ensure the state exists
                    onChange={this.handleOnMonthChange}
                  />

                  <Row type="flex" justify="end" align="right" gutter={16}>
                    <span className={styles.hostSelectTitle}>Host: </span>
                    <Select
                      defaultValue={hostDefaultValue || 'all'} // Ensure default value exists
                      className={styles.hostSelects}
                      showSearch
                      placeholder="Select a host"
                      optionFilterProp="children"
                      onChange={this.handleOnHostChange}
                      filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    >
                      <Option key="all" value="all">
                        All
                      </Option>
                      {filteredHostOptions &&
                        filteredHostOptions.map(host => (
                          <Option key={host.key} value={host.key}>
                            {host.value}
                          </Option>
                        ))}
                    </Select>
                  </Row>
                </>
              )}
            </div>
          )}
          <Table
            loading={!invoices}
            columns={this.columns({ isAdmin: checkIsAdmin(), isAdminReadOnly: checkIsAdminReadOnly() })}
            dataSource={invoices}
          />
        </Card>
      </>
    );
  }
}

export default withRouter(withAppContext(BillingInvoice));
